(function () {
    pagination(false);

    var goToTop = function () {
        $('.js-gotop').on('click', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $('html').offset().top
            }, 500, 'swing');
            return false;
        });
        $(window).scroll(function () {
            var $win = $(window);
            if ($win.scrollTop() > 200) {
                $('.js-top').addClass('active');
            } else {
                $('.js-top').removeClass('active');
            }
        });
    };
    goToTop();

    var head = $(".gh-portal-triggerbtn-iframe").contents().find("head");
    console.log("iframe head", head)
    head.append($("<link/>", {
        rel: "stylesheet",
        href: "/assets/css/iframe.css",
        type: "text/css"
    }));

})();
